import type { Fieldset } from "@/static/types";
import { translate } from "@/locale/translate";

export const assertEmptyFields = (
  userType: keyof Fieldset<any>,
  fieldset: Fieldset<HTMLInputElement>[typeof userType],
  errors: Fieldset<string>[typeof userType],
  lang: string,
) => {
  for (const el in fieldset) {
    const key = el as keyof typeof fieldset;
    if (!fieldset[key].value) {
      errors[key] = translate("Заполните это поле", lang);
    }
  }
};
